module.exports = __webpack_public_path__ + "img/play-circle-icon.f837bc85.svg";